import { useState } from "react";
import { useSelector } from "react-redux";

import "../components/ErrorScreen.css";
import logo from "../assets/EPTICONO.svg";

import { motion } from "framer-motion";
import { modalVariants } from "../animations/transitions";

import { useTranslation } from "react-i18next";

const ErrorScreen = () => {
  const fetchingMessage = useSelector((state) => state.data.fetchingMessage);
  const fetchingCode = useSelector((state) => state.data.fetchingCode);
  const codeId = useSelector((state) => state.data.codeId);

  const [t, i18n] = useTranslation("global");

  return (
    <div className="errorscreen__container">
      <motion.div
        className="errorscreen__modal"
        variants={modalVariants}
        initial="hidden"
        animate="visible"
      >
        <div className="errorscreen__imagecontainer">
          <img src={logo} alt="" />
        </div>
        <p className="errorscreen__problema">{t("ERRORSCREEN.problema")}</p>
        <p className="errorscreen__minutos">{t("ERRORSCREEN.minutos")}</p>
        <p
          className="errorscreen__reportar"
          onClick={() => {
            document.location =
              "mailto:info@escolaportbarcelona.com?subject=&body=";
          }}
        >
          info@escolaportbarcelona.com
        </p>
        {/* {fetchingCode !== 400 ? (
          <p className="errorscreen__minutos">
            En unos minutos recarga la página o envíanos un correo con tu
            solicitud.
          </p>
        ) : (
          <>
            <p className="erroscreen__reportar">Reportar el error</p>
            <p className="errorscreen__code">
              400 - {codeId === 1 ? "1" : "2"}
            </p>
          </>
        )} */}
      </motion.div>
    </div>
  );
};

export default ErrorScreen;
